<template>
  <div class="dgd-banner">
    <img-v3 :src="formItem.icon_url" alt="" class="dgd-img" />
    <p>{{ formItem.title }}</p>
  </div>
</template>
<script>
import { mapMutations, mapState } from "vuex";
import { post } from "../../tools/request";
import { emitFormUpdate } from "../../tools/utils";
import {
  ends,
  LOGIN_CONFIG,
  SUPPORT_COUNTRY as sc,
} from "../../tools/constant";

// 手机号基本格式
const REG_PHONE_NUM = /^\d+$/;

export default {
  props: ["formItem", "idx"],
  data() {
    return {
      phoneNum: "",
      phoneNumValidate: false,
      cityList: [],
    };
  },
  mounted() {},
  computed: {
    ...mapState(["_ticket", "_login_btn_text", "_phone_focus_global"]),
    isWA() {
      return true;
    },
    params() {
      return new URLSearchParams(location.search);
    },
    location_country() {
      return this.params.get("location_country");
    },
  },
  methods: {},
  components: {},
};
</script>
<style lang="scss" scoped>
@import "../../css/mixin.scss";
.dgd-banner {
    display: flex;
    align-items: center;
    position: relative;
    top: -1.06rem;
  margin: 0 0.24rem -0.14rem 0.24rem;
  padding: 0.32rem;
  background-image: linear-gradient(180deg, #fffcfc 0%, #f6f6f6 90%);
  box-shadow: .06rem .06rem .3rem 0 rgba(0,0,0,0.06);
  border-radius: .12rem .12rem 0 0;
  color: #333333;
  font-size: .28rem;
  letter-spacing: 0;
  line-height: 0.36rem;
  .dgd-img {
    // float: left;
    flex-shrink: 0;
    width: 0.72rem;
    height: 0.72rem;
    border-radius: 50%;
    margin-right: 0.3rem;
  }
}
</style>


